import { Icons, Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { NavIcon } from '@/experiences/shared/components/nav-icon';
import { NavItemIcon } from '@/domain/navigation/types';
import { useTheme } from '@/contexts/theme-context';

const TILE_SIZE = 38;
const TILE_ICON_SIZE = 20;

interface MobileDrawerNavItemProps {
  active?: boolean;
  icon?: NavItemIcon;
  iconUrl?: string;
  label: string;
  onPress: () => void;
}

export const MobileDrawerNavItem: React.FC<MobileDrawerNavItemProps> = ({
  active,
  icon,
  iconUrl,
  label,
  onPress,
}) => {
  const theme = useTheme();

  const tileIconColor = active
    ? theme.sk.color.icon.ondark
    : theme.sk.color.icon.primary;

  return (
    <XStack
      accessibilityLabel={label}
      accessibilityRole="button"
      accessibilityState={{ selected: Boolean(active) }}
      alignItems="center"
      backgroundColor={
        active ? theme.sk.color.bg.highlight.secondary : 'transparent'
      }
      borderRadius={theme.sk.radii.radiusLarge}
      gap={theme.sk.spacing.spaceSMedium}
      onPress={onPress}
      paddingHorizontal={theme.sk.spacing.spaceSMedium}
      paddingVertical={theme.sk.spacing.spaceSMedium}
      width="100%"
    >
      <>
        <YStack
          alignItems="center"
          backgroundColor={
            active && !iconUrl
              ? theme.sk.color.bg.dark.default
              : theme.sk.color.bg.secondary.default
          }
          borderRadius={theme.sk.radii.radiusMedium}
          flexShrink={0}
          height={TILE_SIZE}
          justifyContent="center"
          width={TILE_SIZE}
        >
          <NavIcon
            color={tileIconColor}
            fallback={
              <Icons.CircleDashed color={tileIconColor} size={TILE_ICON_SIZE} />
            }
            icon={icon}
            iconUrl={iconUrl}
            size={TILE_ICON_SIZE}
          />
        </YStack>
        <YStack flex={1} minWidth={0}>
          <Typography
            bold
            color="$textPrimary"
            numberOfLines={1}
            size="$md"
            variant="body"
          >
            {label}
          </Typography>
        </YStack>
        <Icons.ChevronRight color={theme.sk.color.icon.disabled} size="$18" />
      </>
    </XStack>
  );
};
